import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AppShell } from "@/components/layout/AppShell";
import Login from "@/pages/Login";
import NewSearch from "@/pages/NewSearch";
import TaskQueue from "@/pages/TaskQueue";
import LeadsManager from "@/pages/LeadsManager";
import Settings from "@/pages/Settings";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div data-testid="auth-loading" className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">
        Chargement de la session…
      </div>
    );
  }
  return user ? children : <Navigate to="/login" replace />;
};

const PublicOnly = ({ children }) => {
  const { user } = useAuth();
  return user ? <Navigate to="/" replace /> : children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/" element={<Protected><AppShell /></Protected>}>
              <Route index element={<NewSearch />} />
              <Route path="taches" element={<TaskQueue />} />
              <Route path="leads" element={<LeadsManager />} />
              <Route path="parametres" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
